import { Roles } from '../helpers/users.js'

export default (user) => {
  if ([Roles.SUPER, Roles.SYSADMIN, Roles.RESELLER].some(role => user.roles.includes(role))) {
    return '/admin/accounts'
  }

  if (user.roles.includes(Roles.ADMIN)) {
    return '/admin/dashboard'
  }

  if (user.roles.includes(Roles.COACH)) {
    return '/admin/classes'
  }

  return '/admin/learner'
}